.steps {
  padding-inline: 0;
}

@media (min-width: 768px) {
  .steps {
    padding-inline: var(--mantine-spacing-xl);
  }
}
